<template>
  <div v-if="productData" class="col-12 advGiftRow">
    <div class="row row-mlr-0">
      <div class="col-12 advCartRow">
        <div class="row">
          <div class="col-3 col-md-2 minicart-item-thumb advCartRowImg gift-row-img">
            <div class="thumbnail_container">
              <div class="thumbnail">
                <img :src="imageSrc" :alt="productData.productName"/>
              </div>
            </div>
          </div>
          <div class="col-9 col-md-10 gift-info-row">
            <div class="row row-mlr-0 no-gutters">
              <div class="col-12 m-auto gift-badge-row">
              <span class="gift-badge">
                ΔΩΡΟ
                <span v-if="cartProduct.quantity">
                    <i class="lni lni-close"></i> {{ cartProduct.quantity }}
                </span>!
              </span>
              </div>
              <div class="col-12 m-auto gift-name-row">
                {{ productData.productName }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../vue/store'

export default {
  name: 'AdvCartGiftRow',
  props: {
    miniCart: {
      type: Boolean,
      default: false
    },
    cartProduct: {
      type: Object
    }
  },
  data () {
    return {
      version: '0.0.1'
    }
  },
  computed: {
    productData () {
      return store.getters.getProductById(this.cartProduct.productId)
    },
    imageSrc () {
      return this.productData.hasOwnProperty('productImage') ? this.productData.productImage.list : store.getters.noImage
    }
  }
}
</script>
